(function() {
  var form = document.getElementById('apparel-contact-form');
  if (!form) return;
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var btn = document.getElementById('apparel-submit-btn');
    var successMsg = document.getElementById('apparel-success');
    var errorMsg = document.getElementById('apparel-error');
    btn.disabled = true;
    btn.textContent = 'SENDING...';
    successMsg.style.display = 'none';
    errorMsg.style.display = 'none';
    var formData = new FormData(form);
    fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      body: formData
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.success) {
        successMsg.style.display = 'block';
        form.reset();
        btn.textContent = 'SEND MY REQUEST →';
        btn.disabled = false;
      } else {
        errorMsg.style.display = 'block';
        btn.textContent = 'SEND MY REQUEST →';
        btn.disabled = false;
      }
    })
    .catch(function() {
      errorMsg.style.display = 'block';
      btn.textContent = 'SEND MY REQUEST →';
      btn.disabled = false;
    });
  });
})();

(function() {
  /* Final per-shirt prices (blank + print, S–XL).
   * SPP[garment][tier][frontColors-1][backColors]  (backColors 0 = no back print) */
  var SETUP = 15;
  var TIER_RANGES = [[24,35],[36,71],[72,143],[144,287],[288,599],[600,1199],[1200,3599],[3600,99999]];
  var TIER_LABELS = ["24–35","36–71","72–143","144–287","288–599","600–1,199","1,200–3,599","3,600+"];
  var SPP = {
    light: [
      [[14.83,15.83,17.83,18.83,19.83,21.83,22.83],[15.83,17.83,18.83,19.83,20.83,22.83,24.83],[16.83,18.83,19.83,20.83,22.83,23.83,25.83],[17.83,19.83,20.83,22.83,23.83,24.83,26.83],[19.83,21.83,22.83,23.83,24.83,26.83,27.83],[20.83,22.83,24.83,25.83,26.83,27.83,29.83]],
      [[12.83,14.83,14.83,15.83,16.83,16.83,17.83],[13.83,14.83,15.83,16.83,16.83,17.83,18.83],[13.83,15.83,16.83,16.83,17.83,17.83,18.83],[14.83,16.83,16.83,17.83,17.83,18.83,19.83],[15.83,16.83,17.83,17.83,18.83,19.83,19.83],[15.83,17.83,18.83,18.83,19.83,19.83,20.83]],
      [[11.83,13.83,13.83,14.83,14.83,15.83,15.83],[12.83,13.83,14.83,14.83,15.83,15.83,16.83],[13.83,14.83,14.83,15.83,15.83,16.83,16.83],[13.83,14.83,15.83,15.83,16.83,16.83,17.83],[14.83,15.83,15.83,16.83,16.83,17.83,17.83],[14.83,15.83,16.83,16.83,17.83,17.83,18.83]],
      [[11.83,12.83,12.83,12.83,13.83,13.83,14.83],[11.83,12.83,12.83,13.83,13.83,14.83,14.83],[11.83,12.83,13.83,13.83,13.83,14.83,14.83],[12.83,13.83,13.83,13.83,14.83,14.83,15.83],[12.83,13.83,14.83,14.83,14.83,15.83,15.83],[12.83,14.83,14.83,14.83,15.83,15.83,15.83]],
      [[10.83,11.83,11.83,11.83,12.83,12.83,12.83],[10.83,11.83,11.83,12.83,12.83,12.83,12.83],[11.83,11.83,12.83,12.83,12.83,12.83,13.83],[11.83,12.83,12.83,12.83,13.83,13.83,13.83],[11.83,12.83,12.83,12.83,13.83,13.83,13.83],[11.83,12.83,12.83,13.83,13.83,13.83,14.83]],
      [[9.83,10.83,10.83,11.83,11.83,11.83,11.83],[10.83,10.83,11.83,11.83,11.83,11.83,11.83],[10.83,11.83,11.83,11.83,11.83,11.83,11.83],[10.83,11.83,11.83,11.83,11.83,11.83,12.83],[10.83,11.83,11.83,11.83,11.83,12.83,12.83],[10.83,11.83,11.83,11.83,12.83,12.83,12.83]],
      [[9.83,10.83,10.83,10.83,10.83,10.83,10.83],[9.83,10.83,10.83,10.83,10.83,10.83,10.83],[9.83,10.83,10.83,10.83,10.83,10.83,11.83],[9.83,10.83,10.83,10.83,10.83,11.83,11.83],[9.83,10.83,10.83,10.83,11.83,11.83,11.83],[10.83,10.83,10.83,11.83,11.83,11.83,11.83]],
      [[8.83,9.83,9.83,9.83,9.83,9.83,9.83],[8.83,9.83,9.83,9.83,9.83,10.83,10.83],[9.83,9.83,9.83,9.83,10.83,10.83,10.83],[9.83,9.83,9.83,10.83,10.83,10.83,10.83],[9.83,9.83,10.83,10.83,10.83,10.83,10.83],[9.83,9.83,10.83,10.83,10.83,10.83,10.83]]
    ],
    dark: [
      [[15.83,18.83,19.83,20.83,22.83,24.83,null],[16.83,19.83,20.83,22.83,23.83,25.83,null],[17.83,20.83,22.83,23.83,24.83,26.83,null],[19.83,22.83,23.83,24.83,26.83,27.83,null],[20.83,24.83,25.83,26.83,27.83,29.83,null],[null,null,null,null,null,null,null]],
      [[13.83,15.83,16.83,16.83,17.83,18.83,19.83],[13.83,16.83,16.83,17.83,17.83,18.83,19.83],[14.83,16.83,17.83,17.83,18.83,19.83,20.83],[15.83,17.83,17.83,18.83,19.83,19.83,20.83],[15.83,18.83,18.83,19.83,19.83,20.83,21.83],[16.83,19.83,19.83,20.83,20.83,21.83,22.83]],
      [[12.83,14.83,14.83,15.83,15.83,16.83,16.83],[13.83,14.83,15.83,15.83,16.83,16.83,17.83],[13.83,15.83,15.83,16.83,16.83,17.83,17.83],[14.83,15.83,16.83,16.83,17.83,17.83,18.83],[14.83,16.83,16.83,17.83,17.83,18.83,18.83],[14.83,16.83,17.83,17.83,18.83,18.83,19.83]],
      [[11.83,12.83,13.83,13.83,14.83,14.83,14.83],[11.83,13.83,13.83,13.83,14.83,14.83,15.83],[12.83,13.83,13.83,14.83,14.83,15.83,15.83],[12.83,14.83,14.83,14.83,15.83,15.83,15.83],[12.83,14.83,14.83,15.83,15.83,15.83,16.83],[13.83,14.83,15.83,15.83,15.83,16.83,16.83]],
      [[10.83,11.83,12.83,12.83,12.83,12.83,13.83],[11.83,12.83,12.83,12.83,12.83,13.83,13.83],[11.83,12.83,12.83,13.83,13.83,13.83,13.83],[11.83,12.83,12.83,13.83,13.83,13.83,14.83],[11.83,12.83,13.83,13.83,13.83,14.83,14.83],[12.83,13.83,13.83,13.83,14.83,14.83,14.83]],
      [[10.83,11.83,11.83,11.83,11.83,11.83,11.83],[10.83,11.83,11.83,11.83,11.83,11.83,12.83],[10.83,11.83,11.83,11.83,11.83,12.83,12.83],[10.83,11.83,11.83,11.83,12.83,12.83,12.83],[10.83,11.83,11.83,12.83,12.83,12.83,12.83],[11.83,11.83,12.83,12.83,12.83,12.83,12.83]],
      [[9.83,10.83,10.83,10.83,10.83,10.83,10.83],[9.83,10.83,10.83,10.83,10.83,11.83,11.83],[9.83,10.83,10.83,10.83,11.83,11.83,11.83],[9.83,10.83,10.83,11.83,11.83,11.83,11.83],[10.83,10.83,11.83,11.83,11.83,11.83,11.83],[10.83,10.83,11.83,11.83,11.83,11.83,11.83]],
      [[8.83,9.83,9.83,9.83,10.83,10.83,10.83],[9.83,9.83,9.83,10.83,10.83,10.83,10.83],[9.83,9.83,10.83,10.83,10.83,10.83,10.83],[9.83,10.83,10.83,10.83,10.83,10.83,10.83],[9.83,10.83,10.83,10.83,10.83,10.83,10.83],[9.83,10.83,10.83,10.83,10.83,10.83,10.83]]
    ]
  };
  var DTF_T = [
    {qty:"1 shirt",min:1,max:1,price:35},
    {qty:"2–5 shirts",min:2,max:5,price:28},
    {qty:"6–11 shirts",min:6,max:11,price:24},
    {qty:"12–23 shirts",min:12,max:23,price:20},
    {qty:"24–35 shirts",min:24,max:35,price:18},
    {qty:"36+ shirts",min:36,max:99999,price:16}
  ];

  var spG = 'light', l1C = 1, l2C = 1, loc2 = false, spQty = 72, dtfQty = 12;

  var EST_NOTE = '<div style="margin-top:12px;font-size:11px;color:#888;line-height:1.6;letter-spacing:.5px"><strong style="color:#ccc">&#x2B21; Starting estimate only.</strong> Your final price depends on your final design, print size, garment, colors and sizes. We confirm everything and send a proof before anything is printed.</div>';

  function fmt(n) { return n != null ? '$' + n.toFixed(2) : 'N/A'; }
  function fmtI(n) { return '$' + Math.round(n).toLocaleString(); }
  function spPrice(qi, f, b) { var t = SPP[spG][qi]; return (t && t[f-1]) ? t[f-1][b] : null; }

  function getTierIdx(qty) {
    for (var i = 0; i < TIER_RANGES.length; i++) {
      if (qty >= TIER_RANGES[i][0] && qty <= TIER_RANGES[i][1]) return i;
    }
    return TIER_RANGES.length - 1;
  }

  function getDTFTierIdx(qty) {
    for (var i = 0; i < DTF_T.length; i++) {
      if (qty >= DTF_T[i].min && qty <= DTF_T[i].max) return i;
    }
    return DTF_T.length - 1;
  }

  function clampSP(v) { return Math.max(24, Math.min(9999, parseInt(v) || 24)); }
  function clampDTF(v) { return Math.max(1, Math.min(9999, parseInt(v) || 1)); }

  window.tpAdjQty = function(d) {
    spQty = clampSP(spQty + d);
    document.getElementById('tp-qty-input').value = spQty;
    tpRender();
  };
  window.tpOnQtyInput = function(v) {
    var n = parseInt(v);
    if (!isNaN(n) && n >= 24) { spQty = Math.min(9999, n); tpRender(); }
  };
  window.tpAdjDTFQty = function(d) {
    dtfQty = clampDTF(dtfQty + d);
    document.getElementById('tp-dtf-qty').value = dtfQty;
    tpRenderDTF();
  };
  window.tpOnDTFQtyInput = function(v) {
    var n = parseInt(v);
    if (!isNaN(n) && n >= 1) { dtfQty = Math.min(9999, n); tpRenderDTF(); }
  };

  function tpBannerHTML(type, title, body, btnText, btnAction) {
    var iconColor = type === 'vol' ? '#6b8c52' : (type === 'mild' ? '#886600' : '#cc8800');
    var titleColor = type === 'vol' ? '#6b8c52' : (type === 'mild' ? '#886600' : '#cc8800');
    var tag = btnAction === 'vol' ? 'a' : 'button';
    return '<div class="tp-rec-head"><span style="color:' + iconColor + ';font-size:14px">&#x2B21;</span>' +
      '<span class="tp-rec-title" style="color:' + titleColor + '">' + title + '</span></div>' +
      '<div class="tp-rec-body">' + body + '</div>' +
      '<' + tag + ' class="tp-rec-btn">' + btnText + '</' + tag + '>';
  }

  function tpRender() {
    spQty = clampSP(document.getElementById('tp-qty-input').value);
    document.getElementById('tp-qty-input').value = spQty;
    var qi = getTierIdx(spQty);
    document.getElementById('tp-qty-tier').innerHTML = 'TIER: <span>' + TIER_LABELS[qi].toUpperCase() + ' PIECES</span>';

    var frontOnly = spPrice(qi, l1C, 0);
    var perShirt = null, l2Add = null;
    if (frontOnly != null) {
      if (loc2) {
        perShirt = spPrice(qi, l1C, l2C);
        if (perShirt != null) l2Add = perShirt - frontOnly;
      } else {
        perShirt = frontOnly;
      }
    }

    var l1Setup = l1C * SETUP, l2Setup = loc2 ? l2C * SETUP : 0, totalSetup = l1Setup + l2Setup;
    var shirtTotal = perShirt != null ? perShirt * spQty : null;
    var grandTotal = shirtTotal != null ? shirtTotal + totalSetup : null;

    document.getElementById('tp-l1-sel').textContent = l1C + ' color' + (l1C > 1 ? 's' : '') + ' selected — ' + l1C + ' screen' + (l1C > 1 ? 's' : '') + ' × $' + SETUP + ' = $' + l1Setup + ' setup fee';
    if (loc2) document.getElementById('tp-l2-sel').textContent = l2C + ' color' + (l2C > 1 ? 's' : '') + ' selected — ' + l2C + ' screen' + (l2C > 1 ? 's' : '') + ' × $' + SETUP + ' = $' + l2Setup + ' setup fee';

    var tip = document.getElementById('tp-garment-tip');
    if (spG === 'dark') {
      tip.textContent = 'Dark garments need extra ink layers so your colors show up vividly. Expect a small per-shirt increase vs white or light.';
      tip.className = 'tp-garment-tip tp-dark-tip';
    } else {
      tip.textContent = 'White and light garments print at the base price — no extra ink layers needed.';
      tip.className = 'tp-garment-tip';
    }

    var sumEl = document.getElementById('tp-summary');
    if (perShirt != null) {
      var l2Row = loc2 ? '<div class="tp-sum-row"><span class="tp-sum-name">BACK PRINT — ' + l2C + ' COLOR' + (l2C > 1 ? 'S' : '') + '</span><span class="tp-sum-val">+' + fmt(l2Add) + ' / SHIRT</span></div>' : '';
      sumEl.innerHTML = '<div class="tp-sum-title">STARTING ESTIMATE — ' + spQty + ' SHIRTS · ' + (spG === 'light' ? 'WHITE / LIGHT' : 'DARK') + ' · S–XL</div>' +
        l2Row +
        '<div class="tp-sum-row"><span class="tp-sum-name">STARTING PRICE PER SHIRT</span><span class="tp-sum-val tp-sum-val-hero">' + fmt(perShirt) + '</span></div>' +
        '<div class="tp-sum-row"><span class="tp-sum-name">× ' + spQty + ' SHIRTS</span><span class="tp-sum-val tp-sum-val-muted">' + fmtI(shirtTotal) + '</span></div>' +
        '<div class="tp-sum-row"><span class="tp-sum-name">SCREEN SETUP FEE</span><span class="tp-sum-val tp-sum-val-muted">$' + totalSetup + '</span></div>' +
        '<div class="tp-setup-breakdown">' + l1C + ' FRONT SCREEN' + (l1C > 1 ? 'S' : '') + ' × $' + SETUP + ' = $' + l1Setup + (loc2 ? ' &nbsp;+&nbsp; ' + l2C + ' BACK SCREEN' + (l2C > 1 ? 'S' : '') + ' × $' + SETUP + ' = $' + l2Setup : '') + '</div>' +
        '<div class="tp-sum-row tp-sum-total"><span class="tp-sum-name" style="color:#aaaaaa;font-weight:bold;letter-spacing:2px">ESTIMATED TOTAL</span><span class="tp-sum-val tp-sum-val-green">' + fmtI(grandTotal) + '</span></div>' + EST_NOTE;
    } else {
      sumEl.innerHTML = '<div class="tp-sum-title" style="color:#cc4444">N/A — ADJUST YOUR SELECTION</div>';
    }

    document.getElementById('tp-tbl-sub').textContent = (spG === 'light' ? 'WHITE / LIGHT' : 'DARK') + ' · FRONT COLORS BY COLUMN' + (loc2 ? ' + ' + l2C + '-COLOR BACK INCLUDED' : '');
    var tbody = '';
    for (var i = 0; i < TIER_RANGES.length; i++) {
      var rh = i === qi;
      var row = '<tr class="' + (rh ? 'tp-row-hl' : '') + '"><td>' + TIER_LABELS[i] + '</td>';
      for (var c = 1; c <= 6; c++) {
        var rr = spPrice(i, c, loc2 ? l2C : 0);
        row += '<td class="' + (c === l1C ? 'tp-col-hl' : '') + '">' + (rr != null ? fmt(rr) : '<span style="color:#333">N/A</span>') + '</td>';
      }
      row += '</tr>';
      tbody += row;
    }
    document.getElementById('tp-sp-tbody').innerHTML = tbody;
    var tblNote = document.querySelector('.tp-tbl-note');
    if (tblNote) tblNote.textContent = loc2
      ? 'Per-shirt price includes blank (S–XL) + front print (colors by column) + your ' + l2C + '-color back print. Setup fees not included in table.'
      : 'Per-shirt price for one print location + blank (S–XL). Setup fees not included in table.';
    for (var c = 1; c <= 6; c++) {
      var th = document.getElementById('tp-sth' + c);
      if (th) th.style.backgroundColor = c === l1C ? '#3a4d2e' : '';
    }

    var isSmall = qi === 0, isMid = qi === 1;
    var totalColors = l1C + (loc2 ? l2C : 0);
    var banner = document.getElementById('tp-rec-banner');
    var hint = document.getElementById('tp-l1-hint');

    var cBtns = document.querySelectorAll('#tp-l1-cbtn .tp-cbtn');
    cBtns.forEach(function(b, i) {
      b.classList.remove('tp-cbtn-warn');
      if ((isSmall || isMid) && (i + 1) >= 5) b.classList.add('tp-cbtn-warn');
    });

    if (isSmall && (l1C >= 5 || totalColors >= 7)) {
      hint.style.display = 'inline';
      banner.className = 'tp-rec-banner tp-rec-strong tp-rec-show';
      banner.innerHTML = tpBannerHTML('strong', 'HEADS UP — WE CAN DO THIS, BUT HERE' + String.fromCharCode(39) + 'S OUR HONEST TAKE',
        'A ' + l1C + '-color screen print' + (loc2 ? ' with a ' + l2C + '-color back' : '') + ' on ' + spQty + ' shirts is absolutely doable. But between the per-shirt cost and the <strong style="color:#cc8800">$' + totalSetup + ' setup fee</strong>, your order total reaches <strong style="color:#cc8800">' + (grandTotal != null ? fmtI(grandTotal) : 'a significant number') + '</strong>. For a small run this complex, DTF gives you the same full-color result with no setup fee. We' + String.fromCharCode(39) + 'd genuinely recommend checking it out first.',
        'SEE DTF PRICING INSTEAD →', 'dtf');
      banner.querySelector('.tp-rec-btn').addEventListener('click', function() { tpSwitchMain('dtf'); });
    } else if (isMid && l1C >= 5) {
      hint.style.display = 'inline';
      banner.className = 'tp-rec-banner tp-rec-strong tp-rec-show';
      banner.innerHTML = tpBannerHTML('strong', 'WORTH A LOOK BEFORE YOU COMMIT',
        'A ' + l1C + '-color print at ' + spQty + ' shirts is doable — but the <strong style="color:#cc8800">$' + totalSetup + ' setup fee</strong> still adds up. If this is a one-time design, DTF could save you money here too. Your call — we' + String.fromCharCode(39) + 'll make whichever works best.',
        'COMPARE DTF PRICING →', 'dtf');
      banner.querySelector('.tp-rec-btn').addEventListener('click', function() { tpSwitchMain('dtf'); });
    } else if (isSmall && l1C >= 4) {
      hint.style.display = 'inline';
      banner.className = 'tp-rec-banner tp-rec-mild tp-rec-show';
      banner.innerHTML = tpBannerHTML('mild', 'JUST SO YOU KNOW',
        'A ' + l1C + '-color print at ' + spQty + ' shirts adds a <strong style="color:#886600">$' + totalSetup + ' setup fee</strong> on top of your shirt total. Normal for screen printing, but worth knowing on a small run. DTF might be worth a look.',
        'COMPARE DTF PRICING →', 'dtf');
      banner.querySelector('.tp-rec-btn').addEventListener('click', function() { tpSwitchMain('dtf'); });
    } else if (qi >= 5) {
      hint.style.display = 'none';
      banner.className = 'tp-rec-banner tp-rec-vol tp-rec-show';
      banner.innerHTML = tpBannerHTML('vol', 'VOLUME ORDER — LET' + String.fromCharCode(39) + 'S TALK',
        'At ' + spQty + ' shirts you' + String.fromCharCode(39) + 're in volume territory. Orders at this scale may qualify for additional discounts not shown in the table. Contact us before you finalize.',
        'GET A VOLUME QUOTE →', 'vol');
      var vbtn = banner.querySelector('.tp-rec-btn');
      if (vbtn) vbtn.href = '#apparel-quote-form';
    } else {
      hint.style.display = 'none';
      banner.className = 'tp-rec-banner';
    }
  }

  function tpRenderDTF() {
    dtfQty = clampDTF(document.getElementById('tp-dtf-qty').value);
    document.getElementById('tp-dtf-qty').value = dtfQty;
    var ti = getDTFTierIdx(dtfQty);
    var cur = DTF_T[ti];
    document.getElementById('tp-dtf-tier').innerHTML = 'TIER: <span>' + cur.qty.toUpperCase() + '</span>';

    var callout = document.getElementById('tp-dtf-callout');
    if (cur.price != null) {
      callout.innerHTML =
        '<div class="tp-dc-item"><div class="tp-dc-label">YOUR QUANTITY</div><div class="tp-dc-val">' + dtfQty + '</div><div class="tp-dc-sub">' + cur.qty.toUpperCase() + ' TIER</div></div>' +
        '<div class="tp-dc-item"><div class="tp-dc-label">STARTING PRICE / SHIRT</div><div class="tp-dc-val" style="color:#6b8c52">' + fmt(cur.price) + '</div><div class="tp-dc-sub">BLANK + 1 LOCATION</div></div>' +
        '<div class="tp-dc-item"><div class="tp-dc-label">EXTRA LOCATIONS</div><div class="tp-dc-val">+$5</div><div class="tp-dc-sub">PER SHIRT EACH</div></div>' +
        '<div class="tp-dc-item"><div class="tp-dc-label">ESTIMATED TOTAL</div><div class="tp-dc-val" style="color:#6b8c52">' + fmtI(cur.price * dtfQty) + '</div><div class="tp-dc-sub">' + dtfQty + ' SHIRT' + (dtfQty > 1 ? 'S' : '') + ' · NO SETUP FEE</div></div>' + '<div style="grid-column:1/-1">' + EST_NOTE + '</div>';
    } else {
      callout.innerHTML = '<div class="tp-dc-item" style="grid-column:1/-1"><div class="tp-dc-label">AT ' + dtfQty + ' SHIRTS</div><div class="tp-dc-val" style="color:#6b8c52;font-size:14px;letter-spacing:1px">SCREEN PRINT IS THE BETTER VALUE</div><div class="tp-dc-sub">LOWER COST · MORE DURABLE — BUT WE CAN STILL DO DTF IF YOU NEED IT</div><div style="margin-top:12px"><a href="#apparel-quote-form" style="display:inline-block;background:#000;border:1px solid #4a5c3a;color:#6b8c52;font-size:10px;font-weight:bold;letter-spacing:2px;text-transform:uppercase;padding:8px 16px;text-decoration:none">CONTACT US FOR DTF QUOTE →</a></div></div>';
    }

    var grid = '';
    DTF_T.forEach(function(t, i) {
      var active = i === ti;
      var isLast = i === DTF_T.length - 1;
      if (isLast) {
        grid += '<div class="tp-dtf-card' + (active ? ' tp-dtf-active' : '') + '" onclick="tpSelectDTFTier(' + i + ')"><div class="tp-dtf-qty-label">' + t.qty.toUpperCase() + '</div><div class="tp-dtf-price">' + fmt(t.price) + '</div><div class="tp-dtf-unit">PER SHIRT · 1 LOCATION</div><div class="tp-dtf-perk">+$5 EACH EXTRA LOCATION</div><div style="font-size:8px;color:#cc8800;font-weight:bold;letter-spacing:1px;margin-top:4px;text-transform:uppercase">Screen print may save more</div></div>';
      } else {
        grid += '<div class="tp-dtf-card' + (active ? ' tp-dtf-active' : '') + '" onclick="tpSelectDTFTier(' + i + ')"><div class="tp-dtf-qty-label">' + t.qty.toUpperCase() + '</div><div class="tp-dtf-price">' + fmt(t.price) + '</div><div class="tp-dtf-unit">PER SHIRT · 1 LOCATION</div><div class="tp-dtf-perk">+$5 EACH EXTRA LOCATION</div></div>';
      }
    });
    document.getElementById('tp-dtf-grid').innerHTML = grid;
    var oldNote = document.getElementById('tp-dtf-sp-note');
    if (oldNote) oldNote.parentNode.removeChild(oldNote);
    if (dtfQty >= 24) {
      var note = document.createElement('div');
      note.id = 'tp-dtf-sp-note';
      note.style.cssText = 'margin-top:10px;padding:10px 14px;border:1px solid #cc8800;background:#0f0a00;font-size:11px;color:#cc8800;letter-spacing:1px;';
      note.innerHTML = '&#x2B21; At ' + dtfQty + ' shirts, screen printing typically costs less per shirt and has a more durable finish. We can do DTF — <a href="#apparel-quote-form" style="color:#6b8c52;text-decoration:none;font-weight:bold;">contact us</a> if that is what you need.';
      var grid_el = document.getElementById('tp-dtf-grid');
      grid_el.parentNode.insertBefore(note, grid_el.nextSibling);
    }
  }

  window.tpSelectDTFTier = function(i) {
    if (DTF_T[i].price == null) return;
    dtfQty = DTF_T[i].min;
    document.getElementById('tp-dtf-qty').value = dtfQty;
    tpRenderDTF();
  };

  window.tpToggleLoc2 = function() {
    loc2 = document.getElementById('tp-loc2-toggle').checked;
    var body = document.getElementById('tp-loc2-body');
    body.classList.toggle('tp-loc2-open', loc2);
    var badge = document.getElementById('tp-loc2-badge');
    badge.textContent = loc2 ? 'ADDED' : 'OPTIONAL';
    badge.className = 'tp-loc-badge' + (loc2 ? '' : ' tp-loc-badge-opt');
    tpRender();
  };

  window.tpSetG = function(g, el) {
    spG = g;
    document.querySelectorAll('.tp-tog').forEach(function(b) { b.classList.remove('tp-tog-on'); });
    el.classList.add('tp-tog-on');
    tpRender();
  };

  window.tpSetL1C = function(c, el) {
    l1C = c;
    document.querySelectorAll('#tp-l1-cbtn .tp-cbtn').forEach(function(b) { b.classList.remove('tp-cbtn-on'); });
    el.classList.add('tp-cbtn-on');
    tpRender();
  };

  window.tpSetL2C = function(c, el) {
    l2C = c;
    document.querySelectorAll('#tp-l2-cbtn .tp-cbtn').forEach(function(b) { b.classList.remove('tp-cbtn-on'); });
    el.classList.add('tp-cbtn-on');
    tpRender();
  };

  window.tpFaq = function(el) {
    el.classList.toggle('tp-faq-open');
    el.nextElementSibling.classList.toggle('tp-faq-a-open');
  };


  var EMB_DATA = {
    small: {
      label: 'SMALL (UP TO 8K STITCHES)',
      hint: 'Small: left chest logo, hat logo, badge — typical law enforcement patch placement. Up to 8,000 stitches.',
      rows: [
        {qty:'1–5', min:1, max:5, p:13.91},
        {qty:'6–11', min:6, max:11, p:12.99},
        {qty:'12–23', min:12, max:23, p:12.37},
        {qty:'24–47', min:24, max:47, p:10.10},
        {qty:'48–71', min:48, max:71, p:8.42},
        {qty:'72–143', min:72, max:143, p:7.47},
        {qty:'144–287', min:144, max:287, p:6.58},
        {qty:'288–575', min:288, max:575, p:5.98},
        {qty:'576–999', min:576, max:999, p:5.40},
        {qty:'1000+', min:1000, max:99999, p:4.90}
      ]
    },
    medium: {
      label: 'MEDIUM (10K–12K STITCHES)',
      hint: 'Medium: standard department logo, unit crest, or chest badge — 10,000 to 12,000 stitches.',
      rows: [
        {qty:'1–5', min:1, max:5, p:21.71},
        {qty:'6–11', min:6, max:11, p:20.03},
        {qty:'12–23', min:12, max:23, p:18.03},
        {qty:'24–47', min:24, max:47, p:16.67},
        {qty:'48–71', min:48, max:71, p:14.67},
        {qty:'72–143', min:72, max:143, p:13.62},
        {qty:'144–287', min:144, max:287, p:12.37},
        {qty:'288–575', min:288, max:575, p:11.64},
        {qty:'576–999', min:576, max:999, p:10.88},
        {qty:'1000+', min:1000, max:99999, p:10.40}
      ]
    },
    large: {
      label: 'LARGE (15K–25K STITCHES)',
      hint: 'Large: full department crest, large back design, or detailed artwork — 15,000 to 25,000 stitches.',
      rows: [
        {qty:'1–5', min:1, max:5, p:29.95},
        {qty:'6–11', min:6, max:11, p:27.35},
        {qty:'12–23', min:12, max:23, p:24.01},
        {qty:'24–47', min:24, max:47, p:22.45},
        {qty:'48–71', min:48, max:71, p:20.77},
        {qty:'72–143', min:72, max:143, p:20.15},
        {qty:'144–287', min:144, max:287, p:17.57},
        {qty:'288–575', min:288, max:575, p:16.35},
        {qty:'576–999', min:576, max:999, p:16.08},
        {qty:'1000+', min:1000, max:99999, p:15.32}
      ]
    }
  };
  var embSize = 'small', embQty = 12;

  function getEmbTierIdx(qty) {
    var rows = EMB_DATA[embSize].rows;
    for (var i = 0; i < rows.length; i++) {
      if (qty >= rows[i].min && qty <= rows[i].max) return i;
    }
    return rows.length - 1;
  }

  function clampEmb(v) { return Math.max(1, Math.min(9999, parseInt(v) || 1)); }

  window.tpAdjEmbQty = function(d) {
    embQty = clampEmb(embQty + d);
    document.getElementById('tp-emb-qty').value = embQty;
    tpRenderEmb();
  };
  window.tpOnEmbQtyInput = function(v) {
    var n = parseInt(v);
    if (!isNaN(n) && n >= 1) { embQty = Math.min(9999, n); tpRenderEmb(); }
  };
  window.tpSetEmbSize = function(size, el) {
    embSize = size;
    document.querySelectorAll('.tp-emb-size-btn').forEach(function(b) { b.classList.remove('tp-emb-size-on'); });
    el.classList.add('tp-emb-size-on');
    document.getElementById('tp-emb-size-hint').textContent = EMB_DATA[size].hint;
    tpRenderEmb();
  };

  function tpRenderEmb() {
    embQty = clampEmb(document.getElementById('tp-emb-qty').value);
    document.getElementById('tp-emb-qty').value = embQty;
    var data = EMB_DATA[embSize];
    var ti = getEmbTierIdx(embQty);
    var row = data.rows[ti];
    var price = row.p;

    document.getElementById('tp-emb-tier').innerHTML = 'TIER: <span>' + row.qty.toUpperCase() + ' PIECES</span>';

    var sumEl = document.getElementById('tp-emb-summary');
    sumEl.innerHTML = '<div class="tp-sum-title">STARTING ESTIMATE — ' + embQty + ' PIECES · ' + data.label + '</div>' +
      '<div class="tp-sum-row"><span class="tp-sum-name">STARTING EMBROIDERY PRICE / PIECE</span><span class="tp-sum-val tp-sum-val-hero">' + fmt(price) + '</span></div>' +
      '<div class="tp-sum-row"><span class="tp-sum-name">× ' + embQty + ' PIECES</span><span class="tp-sum-val tp-sum-val-muted">' + fmtI(price * embQty) + '</span></div>' +
      '<div class="tp-sum-row"><span class="tp-sum-name">LOGO DIGITIZING <span style="font-size:9px;font-weight:normal;color:#444">(FIRST ORDER ONLY — WAIVED IF YOU PROVIDE A DST FILE)</span></span><span class="tp-sum-val tp-sum-val-muted">$25.00</span></div>' +
      '<div class="tp-sum-row tp-sum-total"><span class="tp-sum-name" style="color:#aaaaaa;font-weight:bold;letter-spacing:2px">ESTIMATED DECORATION TOTAL</span><span class="tp-sum-val tp-sum-val-green">' + fmtI(price * embQty + 25) + '</span></div>' +
      '<div style="margin-top:8px;font-size:10px;color:#444444;letter-spacing:1px">Blank item cost not included. Contact us for a full quote with your item sourced.</div>';

    var tbody = '';
    var rows = data.rows;
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      var rh = i === ti;
      tbody += '<tr class="' + (rh ? 'tp-row-hl' : '') + '">' +
        '<td>' + r.qty + '</td>' +
        '<td class="' + (embSize === 'small' ? 'tp-col-hl' : '') + '">' + fmt(EMB_DATA.small.rows[i].p) + '</td>' +
        '<td class="' + (embSize === 'medium' ? 'tp-col-hl' : '') + '">' + fmt(EMB_DATA.medium.rows[i].p) + '</td>' +
        '<td class="' + (embSize === 'large' ? 'tp-col-hl' : '') + '">' + fmt(EMB_DATA.large.rows[i].p) + '</td>' +
        '</tr>';
    }
    document.getElementById('tp-emb-tbody').innerHTML = tbody;
  }
  window.tpSwitchMain = function(t) {
    ['sp', 'dtf', 'emb', 'explain'].forEach(function(id) {
      var tab = document.getElementById('tp-mtab-' + id);
      var panel = document.getElementById('tp-panel-' + id);
      if (tab) { if (id === t) { tab.classList.add('tp-tab-on'); } else { tab.classList.remove('tp-tab-on'); } }
      if (panel) { if (id === t) { panel.classList.add('tp-panel-on'); } else { panel.classList.remove('tp-panel-on'); } }
    });
    if (t === 'emb') { tpRenderEmb(); }
  };


  function init() {
    if (!document.getElementById('tp-qty-input')) return; // not on apparel lab page
    tpRender();
    tpRenderDTF();
    tpRenderEmb();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();